<template>
  <div
    class="position-relative"
    :style="themeStyle"
  >
    <picture v-if="imageData.image">
      <source
        :srcset="`${baseUrl}${webpImage(imageData.image)}`"
        type="image/webp"
      >
      <b-img-lazy
        :src="`${baseUrl}${imageData.image}`"
        class="w-100"
        fluid
        alt
      />
    </picture>
    <div
      v-if="imageData.text"
      class="text-area"
    >
      {{ imageData.text }}
    </div>
  </div>
</template>

<script>

import {
  BImgLazy, // BRow, BCol,
} from 'bootstrap-vue'

export default {
  components: {
    BImgLazy,
  },
  props: {
    imageData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      themeStyle: null,
    }
  },
  computed: {
    baseUrl() {
      return this.$store.state.api.baseUrl
    },
    supportWebp() {
      return this.$store.state.app.supportWebp
    },
  },
  mounted() {
    this.themeStyle = this.imageData.config ? this.imageData.config : null
  },
  methods: {
    webpImage(src) {
      if (!src) return ''
      const webpSrc = src.replace(/\.[^.]+$/, '.webp')
      // const webpSrc = `${src.split('.')[0]}.webp`
      return webpSrc
    },
  },
  setup() {
  },
}
</script>

<style lang="scss" scoped>
$font-size: var(--font-size);
$font-color: var(--font-color);
$header-padding: var(--header-padding);
img {
  min-height: 40px;
}
.text-area {
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  padding: $header-padding;
  font-size: $font-size;
  color: $font-color;
  // transform: translate(0, -50%);
}
</style>
